import { RandomId } from "@swivl-mono/helpers";
import {
  NodeData_Voice,
  NodeInterface,
  NodeType,
  VoiceNodeCommandType,
  VoiceNodeCommand_Call,
  VoiceNodeCommand_Forward,
  VoiceNodeCommand_Hangup,
  VoiceNodeCommand_Media
} from "@swivl-mono/types";
import { Select, SelectItem, Switch } from "@swivl-mono/ui";

import { QuestsDropdown } from "../../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const VoiceNode = {
  Type: NodeType.Voice,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.Voice,
      command: { type: VoiceNodeCommandType.HANGUP, message: "" } as VoiceNodeCommand_Hangup,
      goto: "", // deprecated
      // machineAnsweredGoto: "", // deprecated
      // noAnswerGoto: "", // deprecated
      // timeoutGoto: "", // deprecated
      // blockHumanInterrupts: false,
      sendDigits: "",
      amdHumanQuest: "",
      amdMachineQuest: "",
      amdFallbackQuest: "",
      interruptible: true
    } as NodeData_Voice;
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node as any,
      title: "Voice",
      body: node.command.type.toUpperCase(),
      //   baseWidth: 250,

      // tabs: []
      tabs: node.command.type === VoiceNodeCommandType.MEDIA ? [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }] : []
    });
  },

  InspectorPanel: class VoiceNodeInspectorPanelClass extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    renderCommandOptions(node: NodeData_Voice) {
      switch (node.command.type) {
        case VoiceNodeCommandType.MEDIA:
          return (
            <div>
              <TagInput
                label="Media URL"
                value={node.command.uri}
                onChange={this.onChange}
                name="command.uri"
                placeholder="https://swivl-cdn.s3-us-west-1.amazonaws.com/Audio/background.mp3"
              />
            </div>
          );
        case VoiceNodeCommandType.CALL:
          return (
            <div>
              <TagInput label="Number to Call" value={node.command.to} onChange={this.onChange} name="command.to" />
              {/* <label>Initial Message</label>
              <TagInput
                value={node.command.initialMessage}
                onChange={this.onChange}
                name="initialMessage" />
              <br /> */}
              <TagInput label="Send Digits" value={node.command.sendDigits} onChange={this.onChange} name="command.sendDigits" />
              <br />
              {/* <label>Outbound Quest</label>
              <QuestsDropdown value={node.outboundQuest} name="outboundQuest" onChange={this.onChange} />
              <br /> */}
              <QuestsDropdown
                label="Human Answered:"
                value={node.amdHumanQuest}
                name="amdHumanQuest"
                questSelected={(slug) => this.onChangeSwitch("amdHumanQuest", slug)}
                onClear={() => this.onChangeSwitch("amdHumanQuest", "")}
              />
              <br />
              <QuestsDropdown
                label="Machine Answered:"
                value={node.amdMachineQuest}
                name="amdMachineQuest"
                questSelected={(slug) => this.onChangeSwitch("amdMachineQuest", slug)}
                onClear={() => this.onChangeSwitch("amdMachineQuest", "")}
              />
              <br />
              <QuestsDropdown
                label="Unknown Answered:"
                value={node.amdFallbackQuest}
                name="amdFallbackQuest"
                questSelected={(slug) => this.onChangeSwitch("amdFallbackQuest", slug)}
                onClear={() => this.onChangeSwitch("amdFallbackQuest", "")}
              />
            </div>
          );
        case VoiceNodeCommandType.FORWARD:
          return (
            <div>
              <TagInput label="Forward To" type={TagInputType.SingleLine} value={node.command.to} onChange={this.onChange} name="command.to" />

              <TagInput label="Pre-forward Message" value={node.command.message} onChange={this.onChange} name="command.message" />

              <TagInput
                label="Send Digits"
                type={TagInputType.SingleLine}
                value={node.command.sendDigits}
                onChange={this.onChange}
                name="command.sendDigits"
              />

              {/* <label>Human Answered:</label>
              <QuestsDropdown value={node.amdHumanQuest} name="amdHumanQuest" onChange={this.onChange} />
              <br />
              <label>Machine Answered:</label>
              <QuestsDropdown value={node.amdMachineQuest} name="amdMachineQuest" onChange={this.onChange} />
              <br />
              <label>Unknown Answered:</label>
              <QuestsDropdown value={node.amdFallbackQuest} name="amdFallbackQuest" onChange={this.onChange} /> */}
            </div>
          );
        case VoiceNodeCommandType.HANGUP:
          return (
            <div>
              <TagInput label="Goodbye Message" value={node.command.message} onChange={this.onChange} name="command.message" />
            </div>
          );
          break;
      }
    }

    render() {
      const node = this.props.node as NodeData_Voice;

      return (
        <div className="panel ArrayNodePanel">
          <InspectorNodeHeader title="Voice" id={node.id} />

          <Select
            options={Object.values(VoiceNodeCommandType).map(
              (type): SelectItem => ({
                value: type,
                label: type.charAt(0).toUpperCase() + type.slice(1)
              })
            )}
            selectedValues={[node.command.type || ""]}
            hideClear
            onChange={(vals) => {
              const commandType = vals[0] as VoiceNodeCommandType;
              const updatedNode = { ...this.props.node };
              switch (commandType) {
                case VoiceNodeCommandType.CALL:
                  updatedNode.command = { type: VoiceNodeCommandType.CALL, to: "" } as VoiceNodeCommand_Call;
                  break;
                case VoiceNodeCommandType.FORWARD:
                  updatedNode.command = {
                    type: VoiceNodeCommandType.FORWARD,
                    to: "",
                    message: "Forwarding your call now",
                    sendDigits: ""
                  } as VoiceNodeCommand_Forward;
                  break;
                case VoiceNodeCommandType.HANGUP:
                  updatedNode.command = { type: VoiceNodeCommandType.HANGUP, message: "Goodbye" } as VoiceNodeCommand_Hangup;
                  break;
                case VoiceNodeCommandType.MEDIA:
                  updatedNode.command = {
                    type: VoiceNodeCommandType.MEDIA,
                    uri: "https://swivl-cdn.s3-us-west-1.amazonaws.com/Audio/background.mp3"
                  } as VoiceNodeCommand_Media;
                  break;
              }
              this.onChangeSwitch("command", updatedNode.command);
            }}
          />

          {this.renderCommandOptions(node)}

          <label>Interruptible</label>
          <Switch on={node.interruptible !== false} name="interruptible" onSet={(on: boolean, name?: string) => this.onChangeSwitch(name!, on)} />

          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default VoiceNode;
